import React from "react";
import DashboardHeader from "../../components/Shop/Layout/DashboardHeader";
import DashboardSideBar from "../../components/Shop/Layout/DashboardSideBar";
import DashboardHero from "../../components/Shop/DashboardHero";

const ShopDashboardPage = () => {
  return (
    <div className="shop-dashboard-page-container">
      <DashboardHeader />
      <div className="shop-dashboard-page-content shop-management-layout">
        <div className="shop-dashboard-page-sidebar shop-management-sidebar-slot">
          <DashboardSideBar active={1} />
        </div>
        <main className="shop-management-main-panel">
          <DashboardHero />
        </main>
      </div>
    </div>
  );
};

export default ShopDashboardPage;

